import React from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	textContainer: {
		flex: '1',
		width: '201px',
		minWidth: '0px',
	},
	truncate: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});

export interface UserContentProps {
	name: string;
	jobTitle?: string | null;
}

/**
 * Internal component that renders the user name and optional job title.
 */
function UserContent({ name, jobTitle }: UserContentProps) {
	return (
		<Stack space="space.0" xcss={styles.textContainer}>
			<Box xcss={styles.truncate}>
				<Heading as="h4" size="xxsmall">
					{name}
				</Heading>
			</Box>
			{jobTitle && (
				<Text size="small" color="color.text.subtlest" maxLines={1}>
					{jobTitle}
				</Text>
			)}
		</Stack>
	);
}

export { UserContent };
